import api from './api';

export interface Contact {
  id: number;
  user_id: string;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
  company?: string;
  position?: string;
  address?: string;
  notes?: string;
  type: string;
  created_at: string;
  updated_at: string;
}

export interface ContactCreateInput {
  user_id: string;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
  company?: string;
  position?: string;
  address?: string;
  notes?: string;
  type?: string;
}

export interface ContactUpdateInput extends Partial<ContactCreateInput> {
  id: number;
}

const contactsService = {
  getContacts: async () => {
    const response = await api.get(`/contacts`);
    return response.data;
  },

  getContactById: async (contactId: number, userId: string) => {
    const response = await api.get(`/contacts/${contactId}/${userId}`);
    return response.data;
  },

  createContact: async (data: ContactCreateInput) => {
    const response = await api.post('/contacts', data);
    return response.data;
  },

  updateContact: async (data: ContactUpdateInput) => {
    const response = await api.put('/contacts', data);
    return response.data;
  },

  deleteContact: async (contactId: number, userId: string) => {
    const response = await api.delete(`/contacts/${contactId}/${userId}`);
    return response.data;
  },

  searchContacts: async (userId: string, query: string) => {
    const response = await api.get(`/contacts/search/${userId}?query=${query}`);
    return response.data;
  },
};

export default contactsService;
